import React from "react";
import {
  ChartBarIcon,
  BookOpenIcon,
  BeakerIcon,
} from "@heroicons/react/24/outline"; // pick icons you like
import { useNavigate } from "react-router-dom";
import fallBackImage from '../Assests/images/placeholderimage.jpg'

const apps = [
  {
    name: "Reading Comprehensen",
    users: "1,234 Active Users",
    growth: "+15.2%",
    color: "text-blue-600",
    iconBg: "bg-blue-100",
    iconBorder: "border-blue-200",
    icon: BookOpenIcon,
  },
  {
    name: "Math Explorer",
    users: "1,234 Active Users",
    growth: "+15.2%",
    color: "text-green-600",
    iconBg: "bg-green-100",
    iconBorder: "border-green-200",
    icon: ChartBarIcon,
  },
  {
    name: "Science Lab",
    users: "1,234 Active Users",
    growth: "+15.2%",
    color: "text-orange-600",
    iconBg: "bg-orange-100",
    iconBorder: "border-orange-200",
    icon: BeakerIcon,
  },
  {
    name: "Reading Comprehensen",
    users: "1,234 Active Users",
    growth: "+15.2%",
    color: "text-blue-600",
    iconBg: "bg-orange-100",
    iconBorder: "border-orange-200",
    icon: BookOpenIcon,
  },
  {
    name: "Reading Comprehensen",
    users: "1,234 Active Users",
    growth: "+15.2%",
    color: "text-green-600",
    iconBg: "bg-green-100",
    iconBorder: "border-green-200",
    icon: BookOpenIcon,
  },
  {
    name: "Reading Comprehensen",
    users: "1,234 Active Users",
    growth: "+15.2%",
    color: "text-orange-600",
    iconBg: "bg-orange-100",
    iconBorder: "border-orange-200",
    icon: BookOpenIcon,
  },
];



const TopApplications = ({ data, loader }) => {

  const navigate = useNavigate();

  return (
    <div className="bg-white shadow-md rounded-2xl p-5">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-gray-500 ">Top Applications</h2>
        <button
          onClick={() => navigate("/applications")}
          className="text-primary-600 font-semibold text-md hover:underline"
        >
          Manage All
        </button>
      </div>

      {/* App List */}
      <div className="space-y-3 h-[350px] overflow-y-auto pr-2 scrollbar-hide">
        {loader ?
          <div className="h-[350px] flex items-center justify-center">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
          </div>
          :

          (data && data.length > 0) ? data.map((app, idx) => {
            const Icon = app.icon;
            return (
              <div
                key={idx}
                className="flex justify-between items-center p-4 border rounded-xl hover:bg-gray-50  "
              >
                <div className="flex items-center space-x-3">
                  {/* Icon */}
                  <div
                    className={`w-12 h-12 rounded-lg flex items-center justify-center border ${app.iconBg} ${app.iconBorder}`}
                  >
                    {/* <Icon className={`w-5 h-5 ${app.color}`} /> */}
                    <img src={Icon || fallBackImage} alt="icon" className="w-12 h-12 rounded-lg object-cover"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = fallBackImage;
                      }} />
                  </div>

                  {/* Text */}
                  <div>
                    <p className="text-gray-800 text-[16px] font-medium">{app.name}</p>
                    <p className="text-gray-500 text-[14px]">{Number(app?.active_users || 0).toLocaleString()} Active {app.category}</p>
                  </div>
                </div>

                {/* Growth */}
                <div className="text-right">
                  <p className={`font-semibold ${app.color}`}>{app.week_per}</p>
                  <p className="text-gray-400 text-xs">Vs Last Week</p>
                </div>
              </div>
            );
          }) :
            <div className="text-center h-[350px] content-center">
              <p className="text-gray-400 text-sl">Top applications will appear here once available.</p>
            </div>
        }

      </div>
    </div>
  );
};

export default TopApplications;
